// File upload helpers for messaging

export const FILE_SIZE_LIMITS = {
  image: 10 * 1024 * 1024, // 10MB
  document: 10 * 1024 * 1024, // 10MB
  video: 50 * 1024 * 1024 // 50MB
};

export const ALLOWED_TYPES = {
  image: ['image/png', 'image/jpeg', 'image/jpg'],
  video: ['video/mp4'],
  document: ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
};

export const getFileType = (mimeType) => {
  if (ALLOWED_TYPES.image.includes(mimeType)) return 'image';
  if (ALLOWED_TYPES.video.includes(mimeType)) return 'video';
  if (ALLOWED_TYPES.document.includes(mimeType)) return 'document';
  return null;
};

export const validateFile = (file) => {
  const fileType = getFileType(file.type);
  
  if (!fileType) {
    return { valid: false, error: `File type not supported. Allowed: PNG, JPG, PDF, DOCX, MP4` };
  }
  
  const sizeLimit = FILE_SIZE_LIMITS[fileType];
  if (file.size > sizeLimit) {
    const limitMB = sizeLimit / (1024 * 1024);
    return { valid: false, error: `File too large. Max size: ${limitMB}MB` };
  }
  
  return { valid: true, fileType };
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export const getFileExtension = (filename) => {
  return filename.split('.').pop().toUpperCase();
};
